import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { officialCategoryName } from "@intelligems/ig-utils";
import { Box, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useReadOnlyMode } from "@src/features/publicShareLinks/hooks/useReadOnlyMode";
import { SETTINGS_ROUTES } from "@src/routes/routes";
import { selectedExperience } from "@src/store/slices/experiences";
import { SettingsSectionId } from "@src/types/navigation";

export const NoCogsSectionPlaceholder = () => {
  const navigate = useNavigate();
  const experience = useSelector(selectedExperience);
  const theme = useTheme();
  const { isReadOnly } = useReadOnlyMode();
  return (
    <Box
      sx={{
        borderTopLeftRadius: "10px",
        borderTopRightRadius: "10px",
        borderBottomLeftRadius: "10px",
        borderBottomRightRadius: "10px",
        backgroundColor: "white",
        marginTop: "15px",
      }}
    >
      <Grid
        container
        sx={{ padding: "45px 30px" }}
        direction={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        textAlign={"center"}
      >
        <Grid>
          <IgTypography fontWeight={600} color={theme.palette.text.secondary}>
            COGS NEEDED
          </IgTypography>
        </Grid>
        <Grid width={450}>
          <IgTypography color={theme.palette.text.secondary}>
            To view profit metrics please enter COGS for more of the revenue
            generating products in this{" "}
            {officialCategoryName(experience.category, false)}.
          </IgTypography>
        </Grid>
        {!isReadOnly && (
          <Grid marginTop={"20px"}>
            <IgButton
              variant={"outlined"}
              onClick={() => {
                void navigate(
                  `${SETTINGS_ROUTES.Settings}#${SettingsSectionId.Cogs}`
                );
              }}
            >
              PROVIDE COGS
            </IgButton>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
